import { split } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';
import { isBrowser } from '~/constants';
import wsLink from './ws';
import httpLink from './http';

const splitLink = isBrowser
    ? split(
          ({ query }) => {
              const definition = getMainDefinition(query);
              return !(
                  definition.kind === 'OperationDefinition' &&
                  definition.operation === 'subscription'
              );
          },
          httpLink,
          wsLink
      )
    : httpLink;

export default splitLink;
